export const fieldGroupStyle = {
  padding: '20px',
  marginBottom: '16px',
  backgroundColor: '#f8f9fa',
  border: '1px solid #e9ecef',
  borderRadius: '8px',
};

export const labelStyle = {
  display: 'block',
  fontWeight: 600,
  marginBottom: '6px',
  color: '#333',
};

export const helpTextStyle = {
  fontSize: '13px',
  color: '#666',
  marginBottom: '10px',
};

export const sectionHeaderStyle = {
  marginTop: 0,
  marginBottom: '24px',
};

export const toggleContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  padding: '12px 16px',
  backgroundColor: '#f8f9fa',
  borderRadius: '6px',
  marginBottom: '20px',
};
